import module from 'nominas/sumario/module.js'
import template from './template.html'

export class NominasSumarioListaItemImportes {
  suministro
  empresaOp = {}
  empresaSa = {}
  expandirImporte = false
  mostrarOp = false

  $onInit () {
    if (this.empresaOp.id === this.empresaSa.id && this.empresaOp.comision === this.empresaSa.comision &&
      this.empresaOp.iva === this.empresaSa.iva && this.empresaOp.kardex_id_empleado === this.empresaSa.kardex_id_empleado
      && this.empresaOp.nombre === this.empresaSa.nombre && this.empresaOp.otros === this.empresaSa.otros &&
      this.empresaOp.subtotal === this.empresaSa.subtotal && this.empresaOp.total === this.empresaSa.total) {
      this.mostrarOp = true
    }
  }
}

module.component('nominasSumarioListaItemImportes', {
  controller: NominasSumarioListaItemImportes,
  template,
  bindings: {
    suministro: '<',
    empresaOp: '<',
    empresaSa: '<',
    expandirImporte: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/lista/item/importes/component.js